import React from 'react'
import { useTranslation } from 'react-i18next';
import classes from '../styles.module.scss';
import { createCn } from '../../../helpers/utils';
import { Meet, Teams, Zoom } from '../../../assets/pages';
import { BotPlatform, BotSessionResponse } from '../../../services/api.service';
import { botSessionStatusText, isBotSessionFailed } from './bot-connect.helpers';

const cn = createCn('bot-connect-modal', classes);

const PLATFORM_ICON: Record<BotPlatform, React.ReactNode> = {
  meet: <Meet />,
  zoom: <Zoom />,
  teams: <Teams />,
};

interface IProps {
  sessions: BotSessionResponse[];
  loading: boolean;
  onOpenMeeting: (meetingId: string) => void;
}

/** Список последних бот-сессий пользователя — под формой подключения, видимость без
 *  отдельной страницы (задача F2, п.3). */
const BotSessionList = ({ sessions, loading, onOpenMeeting }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('recent')}>
      <div className={cn('recent-heading')}>{t('bot-connect.recent-heading')}</div>

      {loading && (
        <div className={cn('recent-empty')}>{t('bot-connect.recent-loading')}</div>
      )}

      {!loading && sessions.length === 0 && (
        <div className={cn('recent-empty')}>{t('bot-connect.recent-empty')}</div>
      )}

      {!loading && sessions.length > 0 && (
        <ul className={cn('recent-list')}>
          {sessions.map((session) => (
            <li key={session.id} className={cn('recent-item')}>
              <span className={cn('recent-icon')}>{PLATFORM_ICON[session.platform]}</span>
              <div className={cn('recent-info')}>
                <span className={cn('recent-url')} title={session.meeting_url}>{session.meeting_url}</span>
                <span className={cn('recent-status', { failed: isBotSessionFailed(session.status) })}>
                  {botSessionStatusText(t, session)}
                </span>
              </div>
              {session.meeting_id && (
                <button
                  type="button"
                  className={cn('recent-link')}
                  onClick={() => onOpenMeeting(session.meeting_id as string)}
                >
                  {t('bot-connect.status-done-link')}
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BotSessionList;
